import { createContext } from 'react';

import type { TKProfile } from '../hooks/keycloak';

import type { AuthInitStatus } from './authInit.types';

export type { AuthInitStatus } from './authInit.types';

/**
 * Контракт контекста аутентификации (Keycloak + статус bootstrap).
 */
export interface IAuthContext {
  /**
   * Редирект на интерактивный вход Keycloak.
   *
   * @returns {Promise<void>}
   */
  login(): Promise<void>;

  /**
   * Завершение сессии и редирект при необходимости.
   *
   * @param {string} [redirectUri] — URI после выхода
   * @returns {Promise<void>}
   */
  logout(redirectUri?: string): Promise<void>;

  /**
   * Обновление access token через keycloak-js.
   *
   * @returns {Promise<void>}
   */
  refresh(): Promise<void>;

  /** Текущий токен, `false` при ошибке адаптера, `null` если сессии нет */
  kToken: string | null | boolean;

  /** Этап первичной инициализации Keycloak */
  initStatus: AuthInitStatus;

  /** Ошибка init при `initStatus === 'error'` */
  initError: Error | null;

  /** Claims из JWT при активной сессии */
  kProfile: TKProfile | null;
}

const defaultAuth: IAuthContext = {
  login: async () => {},
  logout: async (_redirectUri?: string) => {},
  refresh: async () => {},
  kToken: null,
  initStatus: 'pending',
  initError: null,
  kProfile: null,
};

const AuthContext = createContext<IAuthContext>(defaultAuth);

export default AuthContext;
